import React, { Component } from "react";
import Loader from "react-loader-spinner";
import auth from "../../components/auth";
import Back from "../../components/goBack";
import { url } from "../../components/url";
import "./UpdateBusiness.css";

class UpdateBusiness extends Component {
  state = {
    company_tin: "",
    date_of_inc: "",
    ward: "",
    issuance_place: "",
    mobile_no: "",
    info: "",
    isShowLoader: false,
    displayErrors: false
  };

  componentDidMount() {
    this.getTpInfo(JSON.parse(localStorage.MobileBusinessBntinId));
  }

  getTpInfo = data => {
    this.setState({ info: data });
  };

  logout = () => {
    auth.logout(() => {
      localStorage.removeItem("BRHMMobileToken");
    });
    this.props.history.push("/");
  };

  goBack = () => {
    this.props.history.push("/viewbustp");
  };

  setCompTin = val => {
    this.setState({ company_tin: val.target.value });
  };

  setDateofInc = val => {
    this.setState({ date_of_inc: val.target.value });
  };

  setWard = val => {
    this.setState({ ward: val.target.value });
  };

  setIssuance = val => {
    this.setState({ issuance_place: val.target.value });
  };

  setMobileNo = val => {
    this.setState({ mobile_no: val.target.value });
  };

  showLoader = event => {
    event.preventDefault();
    if (!event.target.checkValidity()) {
      // form is invalid! so we do nothing
      // alert('not valid')
      this.setState({ displayErrors: true });
      return;
    } else {
      this.setState({ displayErrors: false, isShowLoader: true });
      setTimeout(() => {
        this.submitForm();
      }, 1000);
    }
  };

  submitForm = () => {
    let confirm = window.confirm("Are you certain of the details entered?");
    if (confirm === true) {
      this.updateTaxPayerHandler();
    } else {
      this.setState({ isShowLoader: false });
    }
  };

  updateTaxPayerHandler = () => {
    let formData = JSON.stringify({
      name: "updateBusiness",
      param: {
        company_tin: this.state.company_tin,
        date_of_inc: this.state.date_of_inc,
        ward: this.state.ward.toUpperCase(),
        issuance_place: this.state.issuance_place.toUpperCase(),
        mobile_no: this.state.mobile_no,
        myKgtin: this.state.info.BNTIN
      }
    });
    console.log(formData);

    fetch(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.BRHMMobileToken
      },
      method: "POST",
      body: formData
    })
      .then(response => response.json())
      .then(res => {
        // console.log(res);

        if (res.hasOwnProperty("response") && res.response === true) {
          alert("Tax Payer Has Been Successfully Updated!");
          this.props.history.push("/viewbus");
        } else if (res.hasOwnProperty("error")) {
          alert(res.error.message);
          if (res.error.message === "Expired token") {
            this.logout();
          }
        } else {
          alert(res.response);
        }
      })
      .then(this.setState({ isShowLoader: false }))
      .catch(error => {
        this.setState({ isShowLoader: false });
        if (error + "" === "TypeError: Failed to fetch") {
          alert(
            "Please check if the device is connected to stable cellular data plan or WiFi."
          );
        }
      });
  };

  render() {
    const { displayErrors } = this.state;

    return (
      <div>
        <Back clickHandler={this.goBack} />
        <div />
        <form
          style={styles.container}
          onSubmit={this.showLoader}
          className={displayErrors ? "displayErrors" : "nodisplayErrors"}
          noValidate
        >
          <input
            type="number"
            pattern="\d+"
            placeholder="Company Tin"
            onChange={this.setCompTin}
            style={styles.input}
            defaultValue={this.state.info.companytin}
          />

          <div style={styles.pickerStyle}>
            <label style={styles.label} htmlFor="doi">
              Date of Issuance
            </label>

            <input
              id="doi"
              name="doi"
              onChange={this.setDateofInc}
              type="date"
              pattern="\d{4}\/\d{2}/\d{2}"
              data-parse="date"
              style={styles.box}
              placeholder="01/01/2019"
              defaultValue={this.state.info.date_of_incorporation}
              required
            />
          </div>

          <input
            type="text"
            placeholder="Ward"
            onChange={this.setWard}
            style={styles.input}
            defaultValue={this.state.info.ward}
          />

          <input
            type="text"
            placeholder="Place of Issuance"
            onChange={this.setIssuance}
            style={styles.input}
            defaultValue={this.state.info.issuance_place}
          />

          <input
            type="number"
            pattern="\d+"
            placeholder="Mobile Number"
            onChange={this.setMobileNo}
            style={styles.input}
            defaultValue={this.state.info.mobile_no}
          />

          {this.state.isShowLoader ? (
            <div style={{ alignSelf: "center", marginTop: 10 }}>
              <Loader type="ThreeDots" color="#8cab49" height="40" width="40" />
            </div>
          ) : (
            <button type="submit" style={styles.button}>
              Save
            </button>
          )}
        </form>
      </div>
    );
  }
}

export default UpdateBusiness;

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    marginTop: 10,
    width: "100%",
    maxWidth: "100%",
    alignContent: "center",
    justifyContent: "center",
    alignSelf: "center",
    backgroundColor: "#eee",
    height: "100%"
  },

  button: {
    marginTop: 20,
    width: "30%",
    height: "40px",
    backgroundColor: "#8cab49",
    borderColor: "transparent",
    color: "white",
    alignSelf: "center",
    outline: "none"
  },

  input: {
    display: "flex",
    borderStyle: "solid",
    borderRadius: 9,
    marginBottom: 4,
    height: 40,
    backgroundColor: "white",
    textDecorationLine: "none",
    outline: "none",
    paddingLeft: 10,
    width: "90%",
    alignSelf: "center"
  },
  label: {
    paddingTop: 7,
    width: "50%"
  },

  pickerStyle: {
    display: "flex",
    paddingTop: 5,
    width: "90%",
    justifyContent: "space-around",
    alignSelf: "center"
  },
  box: {
    height: 50,
    outline: "none",
    width: "50%"
  }
};
